import { render, staticRenderFns } from "./ZAlert.vue?vue&type=template&id=81288b94&"
import script from "./ZAlert.vue?vue&type=script&lang=js&"
export * from "./ZAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports